import { useTranslation } from 'react-i18next';
import { useUserPermissions } from '@anytag/auth';
import { ButtonLink } from '@anytag/shared-atoms';
import { useAllUsersQuery } from '@anytag/graphql';
import { Header, ListWithPagination } from '@anytag/shared-molecules';
import { getValuableVariables, getOffset } from '@anytag/shared-utils';
import { useUpdateDocumentTitle } from '@anytag/shared-hooks';
import { UsersFilter, UsersList, useUsersFilter } from '@anytag/shared-organisms';

export const Users = () => {
  const { t } = useTranslation();
  useUpdateDocumentTitle({ title: 'documentTitle.User', appHeader: 'appHeader.User' });
  const { hideAddUserBtn } = useUserPermissions();
  const { page, limit, filter } = useUsersFilter();
  const { data, previousData, loading } = useAllUsersQuery({
    fetchPolicy: 'cache-and-network',
    variables: getValuableVariables({
      limit,
      offset: getOffset(page, limit),
      keyword: filter.keyword,
      countryId: filter.countryId,
      advertiserIds: filter.advertiserIds.map(Number)
    })
  });

  const result = loading ? previousData : data;
  const totalRecords = result?.allUsersCount?.totalNumber;

  return (
    <div>
      <Header>
        {!hideAddUserBtn ? (
          <ButtonLink
            variant="solid"
            to="/user/add"
            title={t('Button.Add User')}
            className="ml-auto min-w-35 capitalize"
            prefixIcon={{ icon: 'plus', size: '10px' }}
          />
        ) : null}
      </Header>

      <ListWithPagination pagination={{ totalRecords }}>
        <UsersFilter />
        <UsersList loading={loading} data={result?.allUsers || []} totalRecords={totalRecords} />
      </ListWithPagination>
    </div>
  );
};
